import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { BrandCard } from './components/BrandsCarousel';
import { SoundWaveBg } from './components/SoundWaveBg';
import SeoHead from '../../components/SeoHead';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const BrandsIndexPage = () => {
  const [brands, setBrands] = useState([]);
  const [store, setStore] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get(`${API_URL}/api/s/mrg`).then(r => setStore(r.data)).catch(() => {});
    axios.get(`${API_URL}/api/s/mrg/brands?with_image=false`)
      .then(r => setBrands(Array.isArray(r.data) ? r.data : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const colors = useMemo(() => {
    const id = store?.identity || {};
    return { primary: id.primary_color || '#1B2A4A', accent: id.accent_color || '#C9A24B', dark: '#1F2933' };
  }, [store]);

  return (
    <div className="bg-[#eef1f5] min-h-screen" data-testid="brands-index">
      <SeoHead
        title="Toutes nos marques de lunettes | MRG Optique & Audition Istres"
        description="Ray-Ban, Gucci, Maui Jim, Chloé, Guess, Vogue, Emporio Armani… Découvrez toutes les grandes marques de lunettes de soleil et de vue chez MRG Optique à Istres."
      />
      {/* Header band */}
      <section className="relative overflow-hidden" style={{ background: `linear-gradient(135deg, ${colors.dark}, ${colors.primary})` }}>
        <SoundWaveBg primary="#ffffff" accent={colors.accent} className="opacity-10" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 py-16 text-center">
          <span className="text-[12px] font-bold uppercase tracking-[0.3em]" style={{ color: colors.accent }}>MRG Optique</span>
          <h1 className="text-white text-[34px] md:text-[52px] font-semibold leading-none mt-2" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Nos marques
          </h1>
          <p className="text-white/70 mt-3 max-w-xl mx-auto text-[15px]">
            Les plus belles griffes de lunettes de soleil et de vue, sélectionnées pour vous.
          </p>
        </div>
      </section>

      <section className="relative">
        <SoundWaveBg primary={colors.primary} accent={colors.accent} />
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 py-12">
          {loading ? (
            <div className="py-24 flex justify-center">
              <div className="w-9 h-9 border-2 border-t-transparent rounded-full animate-spin" style={{ borderColor: colors.primary }} />
            </div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
              {brands.map(b => (
                <BrandCard key={b.id} brand={b} colors={colors} />
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default BrandsIndexPage;
